import { FormGroup } from "@angular/forms";
import { Subject } from "rxjs";
import { DynamicFormHelper } from "./dynamic-form-helper";
import * as i0 from "@angular/core";
// import { DynamicArray } from "./form-arrays/dynamic-array.model";
export class FormService {
    constructor() {
        this.updateDom = new Subject();
    }
    createFormGroup(controls) {
        const formControls = controls.reduce(DynamicFormHelper.createControls, {});
        const form = new FormGroup(formControls);
        return form;
    }
    isDisabled(model) {
        const disabled = model.disabled;
        return disabled;
    }
    // push(formArray: FormArray, model: DynamicArray): void {
    //   if (this.isDisabled(model)) {
    //     return;
    //   }
    //   model.push();
    //   const lastIndex = model.models.length - 1;
    //   formArray.push(model.models[lastIndex].create());
    // }
    // remove(index: number, formArray: FormArray, model: DynamicArray): void {
    //   if (this.isDisabled(model.models[index])) {
    //     return;
    //   }
    //   model.remove(index);
    //   formArray.removeAt(index);
    // }
    // getApiObject(control: AbstractControl): Attribute {
    //   const saveInfo = {
    //     ...(control as any).saveInfo,
    //     value: control.value,
    //   };
    //   const value = this.transform(saveInfo);
    //   saveInfo.value = value;
    //   return saveInfo;
    // }
    // transform(saveInfo: Attribute): string | number {
    //   let value = saveInfo.value;
    //   if (saveInfo.dataType === "date") {
    //     value = DateHelper.format(value as string);
    //   } else if (saveInfo.dataType === "icdcode") {
    //     value = StringHelper.clean(value as string).toUpperCase();
    //   }
    //   return value;
    // }
    markAllAsTouched(form) {
        Object.keys(form.controls).forEach(key => {
            const control = form.get(key);
            control.markAsTouched({ onlySelf: true });
            control.markAsDirty({ onlySelf: true });
        });
        this.updateDom.next();
    }
}
FormService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function FormService_Factory() { return new FormService(); }, token: FormService, providedIn: "root" });
